import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ResultEntrySearchFilter} from "../../models/SearchFilter";
import {OrderService} from "../../services/order.service";
import {BehaviorSubject, of, Subject} from "rxjs";
import {debounceTime, take} from "rxjs/operators";
import {SettingsService} from "../../../../shared/services/settings.service";
import {Order} from "../../models/order";

@Component({
  selector: 'app-result-entry',
  templateUrl: './result-entry.component.html',
  styleUrls: ['./result-entry.component.scss']
})
export class ResultEntryComponent implements OnInit {
  public saved: boolean = false;
  public filters?: ResultEntrySearchFilter;
  public orderId: number = -1;
  public selectedOrders: Order[] = [];
  public abnormalLabel: string = '';
  public drawerOpened: boolean = false;
  public closeDrawer: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  constructor(private orderService: OrderService, private settingsService: SettingsService, private changeDetector: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.settingsService.getResultSettings()
      .pipe(take(1))
      .subscribe(results => {
        this.abnormalLabel = results.abnormalResult;
      });
    this.closeDrawer.subscribe(() => this.drawerOpened = false);
  }

  setFilters(filters: ResultEntrySearchFilter) {
    this.filters = filters;
  }

  openPreviewDrawer(id: number) {
    this.drawerOpened = !this.drawerOpened;
    this.orderId = id;
  }

  ordersSelectionChanged(orders: Order[]) {
    this.selectedOrders = orders;
  }

  onSaved() {
    this.saved = true;
    this.changeDetector.detectChanges();
    of(null)
      .pipe(take(1), debounceTime(1000))
      .subscribe(() => {
        this.saved = false;
      });
  }
}
